import { render, staticRenderFns } from "./PasswordResetConfirmation.vue?vue&type=template&id=c39b2af2&scoped=true"
import script from "./PasswordResetConfirmation.vue?vue&type=script&lang=ts"
export * from "./PasswordResetConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetConfirmation.vue?vue&type=style&index=0&id=c39b2af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39b2af2",
  null
  
)

export default component.exports